export const languages = {
  fr: 'fr',
  en: 'en',
  ru: 'ru',
  fa: 'fa',
  es: 'es',
  it: 'it',
  ar: 'ar',
};